<div
  [(colorPicker)]="config.value"
  [style.background]="config.value"
  [style.width]="'40px'"
  [style.height]="'40px'"
  [style.border]="'1px solid '"
></div>
